// imports
import TimeGridCalendar from '@src/modules/setting/components/content-categories/calendar/TimeGridCalendar'
import CalendarSlot from '@src/modules/setting/components/content-categories/calendar/CalendarSlot.vue'
import TableData from '@src/modules/setting/components/content-categories/calendar/TableData.vue'
import TableHeader from '@src/modules/setting/components/content-categories/calendar/TableHeader.vue'
// exports
export { TimeGridCalendar, CalendarSlot, TableData, TableHeader }
